<template>
  <div :id="$attrs['id']" :class="[[$attrs['class'], gridClasses], {'hm-roomtype-color-picker--disabled': disabledCombined}]" class="hm-roomtype-color-picker">
    <div class="hm-roomtype-color-picker__options">
      <template v-for="idx in 16">
        <div :class="{'active': internalValue === `roomtype-color--${idx}` }" class="hm-roomtype-color-picker__option" @click="toggleState(`roomtype-color--${idx}`)">
          <span :class="`hm-roomtype-color-picker__option__color hm-roomtype-color-picker__option__color--category-${idx}`"></span>
        </div>
      </template>
    </div>
    <div class="hm-roomtype-color-picker__help" v-html="help" />
    <div class="hm-roomtype-color-picker__label" v-html="label" />
  </div>
</template>

<script>

import HmInputMixin from '@/mixins/HmInputMixin';
import GridMixin from '@/mixins/GridMixin';
import HotelmeisterMixin from '@/mixins/HotelmeisterMixin';

export default {
  name: 'HmRoomtypeColorPicker',

  mixins: [HmInputMixin, GridMixin, HotelmeisterMixin],

  methods: {
    toggleState: function (newValue) {
      if (!this.disabledCombined) {
        this.internalValue = this.internalValue === newValue ? null : newValue;
      }
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
@import "~styles/import";
.hm-roomtype-color-picker {
  position: relative;
  padding-top: 0.6rem;
  &--disabled {
    pointer-events: none;

    .hm-roomtype-color-picker {
      &__option {
        background-color: $lightgray;
        &__color {
          background-color: $middlegray !important;
          &:before {
            opacity: 0!important;
          }
        }
      }
    }
  }
  &__options {
    display: grid;
    grid-template-columns: repeat(8, 1fr);
    border: 0.1rem solid $middlegray;
    border-radius: 0.3rem;
    align-items: center;
    justify-items: center;
  }
  &__option {
    border-right: 0.1rem solid $middlegray;
    &:nth-child(8) {
      border-right: none;
    }
    &:nth-child(-n+8) {
      border-bottom: 0.1rem solid $middlegray;
    }
    width: 100%;
    display: grid;
    align-items: center;
    justify-items: center;
    padding: 0.8rem 0;
    &:hover {
      .hm-roomtype-color-picker__option__color {
        &:before {
          opacity: 1;
        }
      }
    }
    &__color {
      width: 1.4rem;
      height: 1.4rem;
      border-radius: 50%;
      position: relative;
      &:before {
        content: "";
        position: absolute;
        width: 2rem;
        height: 2rem;
        border-radius: 50%;
        left: -0.3rem;
        top: -0.3rem;
        display: block;
        opacity: 0;
        transition: opacity 0.2s ease;
      }
      &--category-1 {
        background-color: rgba(#bd487b, 0.6);
        &:before {
          background-color: rgba(#bd487b, 0.4);
        }
      }

      &--category-2 {
        background-color: rgba(#3498db, 0.6);

        &:before {
          background-color: rgba(#3498db, 0.4);
        }
      }

      &--category-3 {
        background-color: rgba(#2ecc71, 0.6);

        &:before {
          background-color: rgba(#2ecc71, 0.4);
        }
      }

      &--category-4 {
        background-color: rgba(#9b59b6, 0.6);

        &:before {
          background-color: rgba(#9b59b6, 0.4);
        }
      }

      &--category-5 {
        background-color: rgba(#34495e, 0.6);

        &:before {
          background-color: rgba(#34495e, 0.4);
        }
      }

      &--category-6 {
        background-color: rgba(#f1c40f, 0.6);

        &:before {
          background-color: rgba(#f1c40f, 0.4);
        }
      }

      &--category-7 {
        background-color: rgba(#1abc9c, 0.6);

        &:before {
          background-color: rgba(#1abc9c, 0.4);
        }
      }

      &--category-8 {
        background-color: rgba(#27ae60, 0.6);

        &:before {
          background-color: rgba(#27ae60, 0.4);
        }
      }

      &--category-9 {
        background-color: rgba(#e74c3c, 0.6);

        &:before {
          background-color: rgba(#e74c3c, 0.4);
        }
      }

      &--category-10 {
        background-color: rgba(#16a085, 0.6);

        &:before {
          background-color: rgba(#16a085, 0.4);
        }
      }

      &--category-11 {
        background-color: rgba(#2980b9, 0.6);

        &:before {
          background-color: rgba(#2980b9, 0.4);
        }
      }

      &--category-12 {
        background-color: rgba(#8e44ad, 0.6);

        &:before {
          background-color: rgba(#8e44ad, 0.4);
        }
      }

      &--category-13 {
        background-color: rgba(#2c3e50, 0.6);

        &:before {
          background-color: rgba(#2c3e50, 0.4);
        }
      }

      &--category-14 {
        background-color: rgba(#f39c12, 0.6);

        &:before {
          background-color: rgba(#f39c12, 0.4);
        }
      }

      &--category-15 {
        background-color: rgba(#d35400, 0.6);

        &:before {
          background-color: rgba(#d35400, 0.4);
        }
      }

      &--category-16 {
        background-color: rgba(#e67e22, 0.6);

        &:before {
          background-color: rgba(#e67e22, 0.4);
        }
      }
    }
    &:last-of-type {
      border-right: none;
    }

    &.active {
      .hm-roomtype-color-picker__option__color {
        &:before {
          opacity: 1;
        }
      }
    }
    &:hover {
      cursor: pointer;
    }
  }
  &__help {
    color: $gray;
    font-size: 1.1rem;
    padding-left: 1rem;
    height: 1.4rem;
    line-height: 1.4rem;
    margin-bottom: 0.3rem;
    margin-top: 0.3rem;
  }
  &__label {
    position: absolute;
    top: 0;
    left: 0.6rem;
    font-size: 1.1rem;
    color: $gray;
    transition: all 0.2s ease;
    z-index: 2;
    pointer-events: none;
    background-color: $white;
    padding: 0 0.4rem;
    border-radius: 0.3rem;
    will-change: top, font-size;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/lib/inputs/HmRoomtypeColorPicker.vue